import { type ReactNode } from 'react'
import { IntlProvider } from 'react-intl'

import { useTranslation } from '../contexts/TranslationContext'

import enMessages from './messages/en.json'
import esMessages from './messages/es.json'
import ptMessages from './messages/pt.json'

import enPrivacyPolicy from './compliance/privacyPolicy/en.json'
import esPrivacyPolicy from './compliance/privacyPolicy/es.json'
import ptPrivacyPolicy from './compliance/privacyPolicy/pt.json'

import enTermsOfUse from './compliance/termsOfUse/en.json'
import esTermsOfUse from './compliance/termsOfUse/es.json'
import ptTermsOfUse from './compliance/termsOfUse/pt.json'

import enTermsOfParticipation from './compliance/termsOfParticipation/en.json'
import esTermsOfParticipation from './compliance/termsOfParticipation/es.json'
import ptTermsOfParticipation from './compliance/termsOfParticipation/pt.json'

export type Locale = keyof typeof allMessages

interface I18nProviderProps {
  children: ReactNode
}

const allMessages = {
  pt: {
    ...ptMessages,
    ...ptPrivacyPolicy,
    ...ptTermsOfUse,
    ...ptTermsOfParticipation
  },
  en: {
    ...enMessages,
    ...enPrivacyPolicy,
    ...enTermsOfUse,
    ...enTermsOfParticipation
  },
  es: {
    ...esMessages,
    ...esPrivacyPolicy,
    ...esTermsOfUse,
    ...esTermsOfParticipation
  }
}

export const I18nProvider = ({ children }: I18nProviderProps) => {
  const [locale] = useTranslation()

  return (
    <IntlProvider locale={locale} messages={allMessages[locale]}>
      {children}
    </IntlProvider>
  )
}
